// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  overBudget: __t.bool().name("over_budget"),
  inputUsed: __t.u128().name("input_used"),
  outputUsed: __t.u128().name("output_used"),
  inputAllowance: __t.u128().name("input_allowance"),
  outputAllowance: __t.u128().name("output_allowance"),
  windowStartedMs: __t.i64().name("window_started_ms"),
  updatedAt: __t.timestamp().name("updated_at"),
});
